module.exports = __webpack_public_path__ + "img/search.8ed0ed1e.svg";